export default "__VITE_ASSET__tfFZgjik__"